import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrganizationRoutingModule } from './organization-routing.module'
import { OrganizationListComponent } from './pages/organization-list/organization-list.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { OrganizationBranchInformationComponent } from './pages/organization-branch-information/organization-branch-information.component'
import { OrganizationBranchBasicInfoComponent } from './components/organization-branch-basic-info/organization-branch-basic-info.component'
import { OrganizationBranchSliderComponent } from './components/organization-branch-slider/organization-branch-slider.component'
import { OrganizationBranchTargetAudienceComponent } from './components/organization-branch-target-audience/organization-branch-target-audience.component'
import { OrganizationBranchLocationComponent } from './components/organization-branch-location/organization-branch-location.component'
import { OrganizationBranchSettingsComponent } from './components/organization-branch-settings/organization-branch-settings.component'
import { OrganizationBranchSocialAccountsComponent } from './components/organization-branch-social-accounts/organization-branch-social-accounts.component'
import { OranizationPendingActionsComponent } from './pages/oranization-pending-actions/oranization-pending-actions.component'
import { ViewBusinessDetailsComponent } from './pages/view-business-details/view-business-details.component'
import { BusinessDetailsOrganizationInfoComponent } from './components/business-details-organization-info/business-details-organization-info.component'
import { OrganizationProfileComponent } from './pages/organization-profile/organization-profile.component'
import { OrganizationProfileBranchesComponent } from './components/organization-profile-branches/organization-profile-branches.component'
import { GoogleMapsModule } from '@angular/google-maps'
import { OrganizationsTableComponent } from './components/organizations-table/organizations-table.component'
import { OrganizationListAccountsPopupComponent } from './components/organization-list-accounts-popup/organization-list-accounts-popup.component'
import { OrganizationFilterComponent } from './components/organization-filter/organization-filter.component'
import { OrganizationSliderUploaderComponent } from './components/organization-slider-uploader/organization-slider-uploader.component'
import { SliderCropperComponent } from './components/organization-slider-uploader/slider-cropper/slider-cropper.component'
import { OrganizationBranchGalleryComponent } from './pages/organization-branch-gallery/organization-branch-gallery.component'
import { LightgalleryModule } from 'lightgallery/angular'
import { UploadGallaryImagesComponent } from './components/upload-gallary-images/upload-gallary-images.component'
import { UploadGallaryVideosComponent } from './components/upload-gallary-videos/upload-gallary-videos.component'
import { OrganizationBranchContactInfoComponent } from './components/organization-branch-contact-info/organization-branch-contact-info.component'
import { DataResolver } from './resolver/pendingActionPageData.resolver.service'
import {
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
	MatMomentDateModule,
} from '@angular/material-moment-adapter'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { StoreModule } from '../store/store.module'

@NgModule({
	declarations: [
		OrganizationListComponent,
		OranizationPendingActionsComponent,
		OrganizationBranchInformationComponent,
		OrganizationBranchBasicInfoComponent,
		OrganizationBranchSliderComponent,
		OrganizationBranchTargetAudienceComponent,
		OrganizationBranchLocationComponent,
		OrganizationBranchSettingsComponent,
		OrganizationBranchSocialAccountsComponent,
		ViewBusinessDetailsComponent,
		BusinessDetailsOrganizationInfoComponent,
		OrganizationProfileComponent,
		OrganizationProfileBranchesComponent,
		OrganizationsTableComponent,
		OrganizationListAccountsPopupComponent,
		OrganizationFilterComponent,
		OrganizationSliderUploaderComponent,
		SliderCropperComponent,
		OrganizationBranchGalleryComponent,
		UploadGallaryImagesComponent,
		UploadGallaryVideosComponent,
		OrganizationBranchContactInfoComponent,
	],
	imports: [
		CommonModule,
		OrganizationRoutingModule,
		SharedModule,
		GoogleMapsModule,
		LightgalleryModule,
		MatDatepickerModule,
		MatMomentDateModule,
		StoreModule,
	],
	exports: [OrganizationListComponent],
	providers: [
		DataResolver,
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
	],
})
export class OrganizationModule {}
